module.exports = require('./dictionary.json');
